import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {AppBar, Box, Button, Toolbar, Typography} from '@mui/material';
import NavigationActions from '../navigationActions';
import {CONST, TokenValidator} from '../../utils';

export default function Holder() {
    const nav = useNavigate();
    const location = useLocation();
    const [logged, setLogged] = useState(false);
    const [checked, setChecked] = useState(false);
    const validate = useCallback(async token => {
        try {
            if (!token || !(await TokenValidator.ValidTokenDate(token))) return false;
            const decoded = await TokenValidator.SimplifyToken(token);
            const roles = Number(decoded.roles ?? decoded.user_data?.roles);
            return Number.isInteger(roles) && ((roles & 2) === 2 || (roles & 4) === 4);
        } catch (_) { return false; }
    }, []);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            let allowed = false;
            try { allowed = await validate(await TokenValidator.GetStaffUser()); } catch (_) { /* invalid storage */ }
            if (cancelled) return;
            setLogged(allowed); setChecked(true);
            if (!allowed && location.pathname !== '/trackinglookup') nav('/trackinglookup', {replace: true});
        })();
        return () => { cancelled = true; };
    }, [location.pathname, nav, validate]);
    const context = useMemo(() => ({Login: {didLogin: setLogged, validate}}), [validate]);
    const logout = () => {
        localStorage.removeItem(CONST.STORAGE_KEYS.STAFF_LOGIN);
        setLogged(false); nav('/trackinglookup', {replace: true});
    };
    return <Box sx={{minHeight: '100vh'}}>
        <AppBar position='static'><Toolbar><NavigationActions />
            <Typography variant='h6' sx={{flex: 1}}>RASTREO DE ÓRDENES</Typography>
            {logged && <Button color='inherit' onClick={logout}>Salir</Button>}
        </Toolbar></AppBar>
        {checked && (logged || location.pathname === '/trackinglookup') && <Outlet context={context} />}
    </Box>;
}
